<div *ngIf="tableDataSource">
    <div mat-dialog-title class="heading">Document Audit
    </div>
    <div>
        <mat-table matSort [dataSource]="tableDataSource" matSortActive="event" matSortDirection="desc" aria-describedby="audit-table">
            <ng-container matColumnDef="event">
                <th id="event" mat-header-cell *matHeaderCellDef mat-sort-header> Event </th>
                <td mat-cell *matCellDef="let row"> {{row.auditevent}} </td>
            </ng-container>
            <ng-container matColumnDef="performer">
                <th id="performer" mat-header-cell *matHeaderCellDef mat-sort-header> Performer </th>
                <td mat-cell *matCellDef="let row"> {{row.performer.priority_user}} </td>
            </ng-container>
            <ng-container matColumnDef="performedOn">
                <th id="performedOn" mat-header-cell *matHeaderCellDef mat-sort-header> Performed on </th>
                <td mat-cell *matCellDef="let row"> {{row.auditdatetime|date:"medium"}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </mat-table>
        <mat-paginator style="padding: 0;margin: 0;" [pageSizeOptions]="[5,10, 20, 50]" [pageSize]="5" showFirstLastButtons>
        </mat-paginator>
    </div>
    <button mat-stroked-button (click)="back()" class="closeButton float-right">Back</button>
</div>